module.exports = __webpack_public_path__ + "static/deploy-1441f5f2b87407dec2bdb49f045924dd.webm";